(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-service"] && !Shopify.designMode) return;
  try {
    
  const initializeCustomerService = (root = document) => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = root.querySelectorAll('.customer-service__reveal:not(.customer-service__reveal--ready)');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('customer-service__reveal--visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('customer-service__reveal--visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      revealItems.forEach((item) => {
        item.classList.add('customer-service__reveal--ready');
        observer.observe(item);
      });
    }

    root.querySelectorAll('.customer-service__faq-item').forEach((details) => {
      const summary = details.querySelector('summary');
      const answer = details.querySelector('.customer-service__faq-answer');

      if (!summary || !answer || summary.dataset.customerServiceAccordion) return;
      summary.dataset.customerServiceAccordion = 'true';

      summary.addEventListener('click', (event) => {
        if (reducedMotion || !answer.animate) return;
        event.preventDefault();

        if (details.dataset.animating === 'true') return;
        details.dataset.animating = 'true';

        const closing = details.open;
        if (!closing) details.open = true;

        const startHeight = closing ? answer.scrollHeight : 0;
        const endHeight = closing ? 0 : answer.scrollHeight;
        const animation = answer.animate(
          [
            { height: `${startHeight}px`, opacity: closing ? 1 : 0 },
            { height: `${endHeight}px`, opacity: closing ? 0 : 1 }
          ],
          { duration: 380, easing: 'ease-out' }
        );

        animation.onfinish = () => {
          if (closing) details.open = false;
          details.dataset.animating = 'false';
        };
      });
    });
  };

  initializeCustomerService();
  document.addEventListener('shopify:section:load', (event) => initializeCustomerService(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-feature"] && !Shopify.designMode) return;
  try {
    
  const initializeStoryFeatureReveals = (root = document) => {
    const sections = root.querySelectorAll('.story-feature:not(.story-feature--reveal-ready)');

    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('story-feature--revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('story-feature--revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach((section) => {
      section.classList.add('story-feature--reveal-ready');
      observer.observe(section);
    });
  };

  initializeStoryFeatureReveals();
  document.addEventListener('shopify:section:load', (event) => initializeStoryFeatureReveals(event.target));

  } catch(e) { console.error(e); }
})();
})();
